import { apiClient } from '@/shared/services/client'
import type {
  ReporteAnalytics,
  PaginatedReportesAnalytics,
  ReporteAnalyticsCreateInput,
  ReporteAnalyticsUpdateInput,
  GrupoDisponible,
} from '../types'

const BASE_URL = '/analytics'

export const analyticsApi = {
  getReportes: async (params?: {
    page?: number
    page_size?: number
    search?: string
    grupo_id?: number
    activo?: boolean
  }): Promise<PaginatedReportesAnalytics> => {
    const { data } = await apiClient.get(`${BASE_URL}/reportes/`, { params })
    return data
  },

  getReporte: async (id: number): Promise<ReporteAnalytics> => {
    const { data } = await apiClient.get(`${BASE_URL}/reportes/${id}/`)
    return data
  },

  createReporte: async (payload: ReporteAnalyticsCreateInput): Promise<ReporteAnalytics> => {
    const { data } = await apiClient.post(`${BASE_URL}/reportes/`, payload)
    return data
  },

  updateReporte: async (id: number, payload: ReporteAnalyticsUpdateInput): Promise<ReporteAnalytics> => {
    const { data } = await apiClient.put(`${BASE_URL}/reportes/${id}/`, payload)
    return data
  },

  deleteReporte: async (id: number): Promise<{ message: string; success: boolean }> => {
    const { data } = await apiClient.delete(`${BASE_URL}/reportes/${id}/`)
    return data
  },

  toggleActivo: async (id: number): Promise<ReporteAnalytics> => {
    const { data } = await apiClient.post(`${BASE_URL}/reportes/${id}/toggle-activo/`)
    return data
  },

  getGruposDisponibles: async (): Promise<GrupoDisponible[]> => {
    const { data } = await apiClient.get(`${BASE_URL}/grupos-disponibles/`)
    return data
  },
}
